import { get, post, del, put } from '@/libs/api.request'

export const getPeople = (id) => {
  return get(`/people/${id}`)
}

export const getAllPeople = (params) => {
  return get('/people', params)
}

export const updatePeople = (id, data) => {
  return put(`/people/${id}`, data)
}

export const createPeople = (data) => {
  return post('/people', data)
}

export const deletePeople = (id) => {
  return del(`/people/${id}`)
}

export const syncPeople = (id) => {
  return get(`/people/sync-from-dingtalk`)
}
